export default __webpack_public_path__ + "static/media/Bolo Ideal.504ab6a7.png";